import { Component, OnInit, ViewChild } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { StoreService } from '@se-po/se-household-setup-data-access-store'
import { SetupBarService } from '@se-po/shared-ui-setup-bar'
import { SeFeDomainEnvironmentService } from 'se-fe-domain-environment'

import { ParentGuardianInfoForm } from './parent-guardian-info-form-service'
import { ParentGuardianInfoSubmitter } from './parent-guardian-info-submit.service'

import { UserServiceCsrfTokenService } from '@se-po/shared-data-access-services'

@Component({
  selector: 'se-po-household-setup-feature-parent-guardian-info',
  templateUrl: './parent-guardian-info.component.html',
  styleUrls: ['./parent-guardian-info.component.scss'],
})
export class ParentGuardianInfoComponent implements OnInit {
  @ViewChild('emailMatchForm') public emailMatchForm: HTMLFormElement

  public ready = false
  public actionUrl: string
  public csrfToken: string

  constructor(
    private domainEnv: SeFeDomainEnvironmentService,
    public formService: ParentGuardianInfoForm,
    public setupBarService: SetupBarService,
    public store: StoreService,
    public submitter: ParentGuardianInfoSubmitter,
    private csrfTokenService: UserServiceCsrfTokenService
  ) { }

  public get form(): UntypedFormGroup {
    return this.formService.form
  }

  public ngOnInit(): void {
    this.formService.createForm()
    this.actionUrl = `${this.domainEnv.getUrl('userService')}users/sign_in`
    this.setupBarService.percentComplete = 50
    this.csrfTokenService.fetchCsrfToken().subscribe(csrfToken => {
      this.csrfToken = csrfToken.csrf_token
      this.ready = true
    })
  }

  public emailMatchSignIn(): void {
    this.submitter.submitting = true
    this.submitter.emailMatchSignIn(this.emailMatchForm)
  }
}
